<template>
  <div>
    <!-- Header -->
    <div class="px-2 py-2">
      <Button
        v-if="!showGraph"
        label="Añadir gráfico"
        @click="showGraph = true"
      />
      <Graph
        v-else
        :editGraph="editGraph"
        :graphs="graphs"
        @save-graph="saveGraph"
        @cancel="handleCancel()"
      />
    </div>

    <!-- Datatable -->
    <DataTable :value="graphs" class="px-2 mt-3">
      <template #empty>
        <div class="p-text-center">
          <span class="p-text-bold">No hay gráficos</span>
        </div>
      </template>
      <Column header="Nombre" field="nombre" />
      <Column header="Título" field="titulo" />
      <Column field="tipo" header="Tipo" />
      <Column>
        <template #body="slotProps">
          <div class="flex gap-2">
            <Button
              @click="handleEditGraph(slotProps.data)"
              icon="pi pi-pencil"
              :disabled="slotProps.data.idGrafico == editGraph?.idGrafico"
            />
            <Button
              @click="deleteGraph(slotProps.data.id)"
              icon="pi pi-trash"
              :disabled="slotProps.data.idGrafico == editGraph?.idGrafico"
              severity="danger"
            />
          </div>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useStore } from "vuex";
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { useConfirm } from "primevue/useconfirm";

import Graph from "@/pages/_root/reports-dialog/form-five/Graph.vue";

// #region Props, Emits
// #endregion

// #region Params, Ref, Reactives, Computed
const confirm = useConfirm();
const store = useStore();
const graphs = ref([]);
const editGraph = ref(null);
const showGraph = ref(false);
// #endregion

// #region Functions
// Open the modal with the data
function loadGraphs(data) {
  if (Object.keys(data).length === 0) return;
  graphs.value = data.relacionGraficos;
}

function handleEditGraph(graph) {
  showGraph.value = true;
  editGraph.value = graph;
}

function deleteGraph(idGrafico) {
  confirm.require({
    message: "¿Desea borrar el gráfico?",
    header: "Borrar",
    icon: "pi pi-exclamation-triangle",
    rejectClass: "p-button-secondary p-button-outlined",
    accept: async () => {
      graphs.value = graphs.value.graph(
        (graph) => graph.idGrafico !== idGrafico
      );
    },
  });
}

function saveGraph(graph) {
  const index = graphs.value.findIndex((g) => g.idGrafico === graph.idGrafico);

  if (index === -1) {
    graphs.value.push(graph);
  } else {
    graphs.value[index] = graph;
  }

  handleCancel();

  store.commit("addGraph", graph);
}

function handleCancel() {
  showGraph.value = false;
  editGraph.value = null;
}

function getData(registerId) {
  const graphsArray = graphs.value;

  /*
    Si no existe el registerId, es que estamos creando un nuevo formulario. Por lo que no
    debemos pasar el idGrafico (ya que el back no lo necesita)
  */
  graphsArray.forEach((filter) => {
    if (!registerId) {
      delete filter.idGrafico;
    }
  });

  return graphsArray;
}
// #endregion

// #region Effects, Hooks
// #endregion

// #region Provide, Expose
defineExpose({
  loadGraphs,
  getData,
});
// #endregion
</script>
